module.exports = "<app-main-nav [showMainNav]=\"showMainNav\"></app-main-nav>\n\n\n<div class=\"container-fluid\">\n  <router-outlet></router-outlet>\n</div>\n<div class=\"loader-screen\" *ngIf=\"showLoader\">\n  <div class=\"mask\">\n\n  </div>\n  <div class=\"spinner\">\n      <i class=\"fa fa-cog fa-spin fa-4x fa-fw\"></i>\n      <span class=\"sr-only\">Loading...</span>\n    </div>\n</div>\n<app-notify></app-notify>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 460
// module chunks = 0